import script from "./SnippetEngagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetEngagement.vue?vue&type=script&setup=true&lang=js"

import "./SnippetEngagement.vue?vue&type=style&index=0&id=5f6137e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6137e2"]])

export default __exports__